import useAxios from 'hooks/useAxios';

export async function getUserSkins(id) {
  const api = useAxios();

  try {
    const res = await api.get(`/skins/skins-for-user/${id}`);
    return res;
  } catch (err) {
    return err;
  }
}
